import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, HttpApiMiddleware, HttpApiSchema } from "effect/unstable/httpapi";
import { StationId, WorkspaceId } from "../development-identifiers.ts";
import { CanonicalTestFormat } from "./canonical.ts";
import { CanonicalTestJson } from "./canonical-report.ts";

const success = /* @__PURE__ */ (() => [CanonicalTestJson,
  Schema.String.pipe(HttpApiSchema.asText({ contentType: "image/svg+xml" })),
  Schema.String.pipe(HttpApiSchema.asText({ contentType: "text/html" }))
])();
// A single-space report retains any native HTTP failure in the bounded 400-599
// interval. Planning and input failures remain JSON for every requested format.
const error = /* @__PURE__ */ (() => Array.from({ length: 200 }, (_, index) => Schema.Union([
  Schema.Struct({ error: Schema.String, code: Schema.optionalKey(Schema.String) }), ...success
]).annotate({ httpApiStatus: 400 + index })))();
const query = /* @__PURE__ */ (() => Schema.Struct({ format: Schema.optionalKey(CanonicalTestFormat) }))();
/** Answers a declared input that fails to decode with the canonical refusal for that request. */
export class CanonicalTestInput extends HttpApiMiddleware.Service<CanonicalTestInput>()("workerstation/hosted-test/CanonicalTestInput") {}
export const CanonicalTestApi = HttpApiGroup.make("canonicalTests").add(
  HttpApiEndpoint.get("station", "/api/stations/:stationId/tests/run", { params: Schema.Struct({ stationId: StationId }), query, success, error }),
  HttpApiEndpoint.get("space", "/api/stations/:stationId/spaces/:workspaceId/tests/run/*", { params: Schema.Struct({ stationId: StationId, workspaceId: WorkspaceId,
    "*": Schema.String.annotate({ description: "all, or a relative test-file path, URL-encoded or with literal slashes" }) }), query, success, error })
).middleware(CanonicalTestInput);
